import { RequestParams, StrapiFilter } from 'strapi/types';

import { MockupChildStrapiPage } from './types';

export const mockupChildPageRequestParams = (
  filter: StrapiFilter
): RequestParams<MockupChildStrapiPage> => {
  return {
    filters: filter,
  };
};
